import { ConfiguratorProductInput, CrisprPrice } from '@src/types/graphql-types'
// This should be ConfiguratorProductInput
// export type ProductDetails = {
//   productType: string
//   participantId: string
//   countryCode: string
//   isRegUser: boolean
//   locale: string
//   isCSR: boolean
//   isCSRSupervisor: boolean
//   sapNextEnabled: boolean
//   accessToken: string
//   timeZone: string
//   guestParticipantId?: string
//   store: string
// }

export type ReviewAndConfirmProp = {
  productDetails: ConfiguratorProductInput
  itemDetails: CrisprPrice[]
  instructions: string
  currencyFormat: string
  thousandSeparator: string
  thousandSpacing: string
  prefixCurrecny: boolean
  decimalSeparator: string
}

export type ConfirmOrderTableProps = {
  productDetails: ConfiguratorProductInput
  instructions: string
  currencyFormat: string
  thousandSeparator: string
  thousandSpacing: string
  prefixCurrecny: boolean
  decimalSeparator: string
}

export type SpecificationsProps = {
  productDetails: ConfiguratorProductInput
  setTermsOpen?: (v: boolean) => void
  itemDetails: CrisprPrice[]
  updateError: (v: string) => void
  currencyFormat: string
  thousandSeparator: string
  thousandSpacing: string
  prefixCurrency: boolean
  decimalSeparator: string
}

export type UploadQueriesProps = {
  productDetails: ConfiguratorProductInput
}

export type CrisprInput = {
  name?: string
  sequence?: string
  laTgtID?: string
  laSequence?: string
  laPam?: string
  laSense?: string
  laStartCoordinate?: string
  raTgtID?: string
  raSequence?: string
  raPam?: string
  raSense?: string
  raStartCoordinate?: string
  distance?: string
  chromosome?: string
  transcripts?: string
  refSeqID?: string
  geneSymbol?: string
  geneID?: string
  species?: string
  laDesignID?: string
  raDesignID?: string
}

export enum ProductUploadType {
  GRNA = 'gRNA',
  Nickase = 'Selected Paired Nickase',
}

type SequenceCommonProps = {
  productDetails: ConfiguratorProductInput
  instructions: string
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>
}
type errorMessageItem = {
  hasError: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  errorMessage: string
}
export interface ManualSearchProps extends SequenceCommonProps {
  errorMessages: errorMessageItem[]
}

export type SequenceEntryItemProps = {
  productDetails: ConfiguratorProductInput
  disable: boolean
  instructions: string
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>
}

export type SequenceListProps = {
  productDetails: ConfiguratorProductInput
  setDisable: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>
}
